const breakpoints = {
    mobile: 768,
    tablet: 1024,
    desktop: 1280,
};

export { breakpoints };
